import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class NonAuthGuard {
  constructor(
    public cookieService: CookieService,
    private router: Router,
  ) {}

  canActivate(): boolean {
    if (this.cookieService.check('access_token')) {
      this.router.navigate(['/dashboard']);
      return false;
    }
    return true;
  }
}
